import styled from 'styled-components';
import theme from '../../styles/theme';

interface Iradio {
  name?: string;
  label: React.ReactNode | string;
  value?: string;
  color?: string;
  checked?: boolean;
  type?: 'box';
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const StyledRadio = styled.label`
  display: inline-block;
  margin-right: 10px;
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
  user-select: none;
  & input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .targetingDescription {
    display: block;
    color: ${theme.colors.grey[400]};
    font-size: 0.8125rem;
    margin-top: 5px;
    padding-right: 10px;
    font-weight: 300;
  }
  input:checked ~ .targetingDescription {
    color: ${theme.colors.primary[200]};
    font-weight: bold;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    width: 16px;
    background-color: ${theme.colors.white};
    border-radius: 50%;
    border: 2px solid ${theme.colors.primary[200]};
    &:after {
      content: '';
      position: absolute;
      display: none;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${theme.colors.primary[200]};
    }
  }
  input:checked ~ .checkmark:after {
    display: block;
  }
  small {
    font-weight: 300;
    color: ${theme.colors.primary[500]};
  }
  input:checked ~ small {
    color: ${theme.colors.primary[200]};
    font-weight: bold;
  }
`;

const Radio = ({ value, name, label, checked, type, onChange }: Iradio) => {
  return (
    <StyledRadio>
      <input
        type="radio"
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <span className="checkmark" /> {label}
      {type === 'box' && <span className="box"></span>}
    </StyledRadio>
  );
};

export default Radio;
